export function fixDecimalsFor(value, decimalsNumber = 2) {
    return parseFloat(value).toFixed(decimalsNumber);
}
